// Funciones puras de la guia (sin React) para poder probarlas.
import { slug } from "modAws/CatalogoAws";
import { disponer, propagar } from "./Diagrama";

export const normalizar = (t) => slug(String(t || ""));

// Nodo que "se cae" por defecto al activar la simulacion
export const nodoFallaDefecto = (d) => (d.falla && d.falla.nodo != null ? d.falla.nodo : d.patron === "abanico" ? 2 : d.patron === "ciclo" ? 1 : Math.floor(d.nodos.length / 2));

// Explicacion de lo que pasa si falla un nodo: la redactada para ese servicio si existe, o una generica segun la forma del diagrama
export const textoFalla = (d, nodo) => {
    if (d.falla && d.falla.nodo === nodo) return d.falla.texto;
    const n = d.nodos[nodo][0];
    if (d.patron === "libre") {
        // diagramas libres (arquitecturas, lecciones, constructor): se simula el recorrido y se cuenta quien se queda sin recibir nada
        const { flujos } = disponer("libre", d.nodos.length, d.nodos, d.flujos);
        const sim = propagar(flujos, d.nodos.length, nodo);
        const sinNada = d.nodos.map((x, i) => [x[0], i]).filter(([, i]) => i !== nodo && !sim.vivos.has(i)).map(([l]) => `«${l}»`);
        return sinNada.length
            ? `Si «${n}» falla, se quedan sin recibir nada: ${sinNada.join(", ")}. Esa pieza es un punto único de falla en este diseño.`
            : `Si «${n}» falla, el resto sigue funcionando: hay otras piezas que cubren su trabajo. Así se diseña para tolerar fallas.`;
    }
    if (d.patron === "abanico") {
        if (nodo >= 2) return `Si «${n}» falla, «${d.nodos[1][0]}» deja de enviarle trabajo y lo reparte entre los destinos que siguen sanos. El servicio se degrada, pero no se corta.`;
        if (nodo === 1) return `Si «${n}» falla, nada llega a los destinos: es un punto único de falla. Por eso se diseña con redundancia en varias zonas.`;
        return `Si «${n}» no envía nada, el resto del diagrama se queda sin trabajo que hacer.`;
    }
    if (d.patron === "ciclo") return `Si «${n}» falla, el ciclo se interrumpe en ese punto: los pasos que siguen no ocurren hasta que se recupere. Conviene vigilarlo con alarmas.`;
    if (nodo === 0) return `Si «${n}» no envía nada, el resto del flujo no se activa.`;
    return `Si «${n}» falla, el recorrido se corta en ese punto y los pasos siguientes no llegan a ocurrir. Por eso se diseña con redundancia (varias zonas o réplicas) y reintentos.`;
};

// Dibujo propio de un objeto: lo que "entra" a esa pieza del diagrama del servicio, la pieza con el nombre del objeto, y lo que "sale".
// Devuelve null si el objeto no esta asociado a ningun nodo o la pieza no tiene conexiones.
export const contextoObjeto = (d, nodoIdx, nombre) => {
    if (nodoIdx == null || !d.nodos[nodoIdx]) return null;
    const { flujos } = disponer(d.patron, d.nodos.length, d.nodos, d.flujos);
    const tramos = flujos.filter(f => !f.retorno).flatMap(f => f.tramos);
    const ent = [...new Set(tramos.filter(t => t.v === nodoIdx).map(t => t.u))];
    const sal = [...new Set(tramos.filter(t => t.u === nodoIdx).map(t => t.v))];
    if (!ent.length && !sal.length) return null;
    const etiqueta = (lista) => (lista.length > 1 ? `${d.nodos[lista[0]][0]} y otros` : d.nodos[lista[0]][0]);
    const nodos = [];
    if (ent.length) nodos.push([etiqueta(ent), d.nodos[ent[0]][1]]);
    nodos.push([nombre, d.nodos[nodoIdx][1]]);
    if (sal.length) nodos.push([etiqueta(sal), d.nodos[sal[0]][1]]);
    const centro = ent.length ? 1 : 0;
    const texto = ent.length && sal.length ? `Recibe de «${nodos[0][0]}» y entrega a «${nodos[2][0]}».`
        : ent.length ? `Recibe de «${nodos[0][0]}»; es el final del recorrido.` : `Es el inicio del recorrido: entrega a «${nodos[1][0]}».`;
    return { nodos, centro, texto };
};

// Texto de busqueda de un servicio (titulo, explicaciones, objetos, cuando usarlo...), normalizado
export const textoBusqueda = (s, d) => normalizar([
    s.title, s.id, d.que, ...(d.pasos || []), ...s.objetos, ...Object.values(d.objetos || {}).map(o => o[0]),
    ...(d.cuando || []), ...(d.evita || []), d.cobro || "",
].join(" "));
